import { getImageSrc } from '../../../../utils/images';
export function getTextureStyles(_ref) {
  var image = _ref.image,
    attachment = _ref.attachment,
    clip = _ref.clip,
    origin = _ref.origin,
    position = _ref.position,
    repeat = _ref.repeat,
    size = _ref.size;
  var imageSrc = getImageSrc(image);
  return {
    backgroundImage: "url(".concat(imageSrc, ")"),
    backgroundAttachment: attachment,
    backgroundClip: clip,
    backgroundOrigin: origin,
    backgroundPosition: position,
    backgroundRepeat: repeat,
    backgroundSize: size
  };
}